/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ResumeDataResponse
 */
export interface ResumeDataResponse {
  /**
   *
   * @type {string}
   * @memberof ResumeDataResponse
   */
  base64Data: string;
  /**
   *
   * @type {string}
   * @memberof ResumeDataResponse
   */
  contentType: string;
  /**
   *
   * @type {string}
   * @memberof ResumeDataResponse
   */
  filename: string;
}

/**
 * Check if a given object implements the ResumeDataResponse interface.
 */
export function instanceOfResumeDataResponse(
  value: object,
): value is ResumeDataResponse {
  if (!("base64Data" in value) || value["base64Data"] === undefined)
    return false;
  if (!("contentType" in value) || value["contentType"] === undefined)
    return false;
  if (!("filename" in value) || value["filename"] === undefined) return false;
  return true;
}

export function ResumeDataResponseFromJSON(json: any): ResumeDataResponse {
  return ResumeDataResponseFromJSONTyped(json, false);
}

export function ResumeDataResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResumeDataResponse {
  if (json == null) {
    return json;
  }
  return {
    base64Data: json["base64Data"],
    contentType: json["contentType"],
    filename: json["filename"],
  };
}

export function ResumeDataResponseToJSON(json: any): ResumeDataResponse {
  return ResumeDataResponseToJSONTyped(json, false);
}

export function ResumeDataResponseToJSONTyped(
  value?: ResumeDataResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    base64Data: value["base64Data"],
    contentType: value["contentType"],
    filename: value["filename"],
  };
}
